module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.shouldShowNotAllowedModal) ? _c('permission-not-allowed-modal') : _vm._e(), _vm._v(" "), (!_vm.current_plan_active) ? _c('upgrade-free-trial') : _vm._e(), _vm._v(" "), (this.shouldShowOnboarding) ? _c('onboarding') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1608a3ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/Modals.vue
// module id = 1822
// module chunks = 0